<template>
  <section class="search-layout">
    <section class="search-layout-s" v-show="!showExpand">
      <slot name="searchMain" />

      <el-form-item v-if="expandSwitchShow">
        <el-button @click="expandSwitch" :icon="expandConfig.icon">
          {{ expandConfig.buttonText }}
        </el-button>
      </el-form-item>

      <slot name="searchFooter" />
    </section>

    <section class="search-layout-s" v-show="showExpand">
      <slot name="searchAll" />

      <el-form-item v-if="expandSwitchShow">
        <el-button @click="expandSwitch" :icon="expandConfig.icon">
          {{ expandConfig.buttonText }}
        </el-button>
      </el-form-item>

      <slot name="searchFooter" />
    </section>
  </section>
</template>

<script setup>
const { proxy } = getCurrentInstance();

const showExpand = ref(false);

const expandSwitch = () => {
  showExpand.value = !showExpand.value;
};

const expandSwitchShow = computed(() => {
  const { searchAll } = proxy.$slots;

  try {
    return typeof searchAll === "function" && searchAll().length > 0;
  } catch (e) {
    console.log(e);
    return false;
  }
});

const expandConfig = computed(() => {
  return showExpand.value
    ? { buttonText: "收起", icon: "ArrowUp" }
    : { buttonText: "展开", icon: "ArrowDown" };
});
</script>

<style lang="scss" scoped>
.search-layout {
  // .search-layout-s {}
}
</style>
